import type { EditorState } from '@tiptap/pm/state';
import { PluginKey } from '@tiptap/pm/state';

interface MentionSuggestionState {
  active: boolean;
}

export const mentionSuggestionPluginKey = new PluginKey<MentionSuggestionState>(
  'mentionSuggestion'
);

export function isMentionSuggestionActive(state: EditorState): boolean {
  return mentionSuggestionPluginKey.getState(state)?.active ?? false;
}

interface HandleTiptapEditorKeyDownOptions {
  event: Pick<KeyboardEvent, 'key' | 'shiftKey' | 'metaKey' | 'ctrlKey'>;
  mode: 'message' | 'note' | 'draft';
  hasContent: boolean;
  mentionSuggestionActive: boolean;
  submit?: () => void;
}

export function handleTiptapEditorKeyDown({
  event,
  mode,
  hasContent,
  mentionSuggestionActive,
  submit,
}: HandleTiptapEditorKeyDownOptions): boolean {
  if (event.key === 'Enter' && mentionSuggestionActive) {
    return false;
  }

  if (mode === 'message' && event.key === 'Enter' && !event.shiftKey) {
    if (hasContent && submit) {
      submit();
      return true;
    }
    return true;
  }

  if (submit && event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
    submit();
    return true;
  }

  return false;
}
